import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: ${(props) => props.theme.colors?.greys?.lighter};
`;

export const LoaderContainer = styled.div`
  width: 16px;
  padding-left: 16px;
`;

export const LabelContainer = styled.div`
  display: flex;
`;
